(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/constants.js');
"use strict";


const WIDGET_ID = {
  seoArticleWidget: 'seo-article-widget',
  impleoWidget: 'impleo-widget'
};
const WIDGET_TAG = {
  seoArticleWidget: 'seo-article-widget',
  impleoWidget: 'impleo-gameinformation'
};
const exported = {
  WIDGET_ID,
  WIDGET_TAG
};
if (svs.isServer) {
  module.exports = exported;
} else {
  setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.constants', exported);
}

 })(window);